module.exports = __webpack_public_path__ + "assets/img/mecha-77981c2c.png";